const mapManufacturerToClient = (serverManufacturer) => {
  if (!serverManufacturer || serverManufacturer.__typename !== "ManufacturerSuccessResponse") {
    return void 0;
  }
  const { address, name } = serverManufacturer.result;
  const { city, country, contactUrl, email, line1, line2, line3, zipCode } = address ?? {};
  if (name || contactUrl || email || Boolean(city && country && (line1 || line2 || line3) && zipCode)) {
    return {
      name: name ?? void 0,
      city: city ?? void 0,
      country: country ?? void 0,
      contactUrl: contactUrl ?? void 0,
      email: email ?? void 0,
      line1: line1 ?? void 0,
      line2: line2 ?? void 0,
      line3: line3 ?? void 0,
      zipCode: zipCode ?? void 0
    };
  }
  return void 0;
};
export {
  mapManufacturerToClient
};
//# sourceMappingURL=map-to-manufacturer.js.map
